import React from 'react';
import {Form} from '@morningtrain/react-resources';
import { LoginPipeline } from '@morningtrain/react-auth'
import * as Fields from 'support/fields';
import {WithTemplate} from '@morningtrain/react-app';
import { Link, useRouter } from '@morningtrain/react-navigation'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'

export default function ResetPassword(props) {

    const router = useRouter();
    const token = router.parameter('token');

    console.log(token);

    return (
        <WithTemplate template={'Auth'}>
            <Form route='auth.password.reset_password'>
                <LoginPipeline/>

                <div className="modal-header">
                    <Translation name='auth.actions.reset_password' />
                </div>

                <div className="form-content">
                    <Fields.Hidden name='token' defaultValue={token} required />
                    <Fields.Input
                        className='mt-6'
                        name='email'
                        type='email'
                        label={<Translation name='fields.email.label' />}
                        required
                    />
                    <Fields.Input
                        className='mt-6'
                        name='password'
                        label={<Translation name='fields.new_password.label' />}
                        type='password'
                        required
                    />
                    <Fields.Input
                        className='mt-6'
                        name='password_confirmation'
                        label={<Translation name='fields.confirm_password.label' />}
                        type='password'
                        required
                    />
                </div>

                <div className="mt-6">
                    <span className="block w-full rounded-md shadow-sm">
                         <button
                             type='submit'
                             className={'w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-500 hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition duration-150 ease-in-out'}>
                            <Translation name='auth.actions.update_password' />
                         </button>
                    </span>
                </div>
            </Form>
        </WithTemplate>
    );
}
